<template>
    <rkm-data-table
        :fields="fields"
        :repository="repositories.formulaExame"
        ref="DataTable"
        sort-by="nome"
    >

        <template v-slot:cell(actions)="{ item }">
            <rkm-button
                @click.stop="$router.push({ name: 'exame-laboratorial-formula-exame-edit', params: { id: item.id } })"
                color="primary"
                title="Editar"
                small
            >
                <rkm-icon icon="pen" />
            </rkm-button>

            <rkm-button
                @click.stop="handleDestroy(item)"
                color="danger"
                title="Excluir"
                small
            >
                <rkm-icon icon="trash" />
            </rkm-button>
        </template>
    </rkm-data-table>
</template>

<script>
// Mixins.
import { repository, error } from '@/mixins'

export default {
    created() {

        this.repositories.formulaExame = this.getConectaSusRepository('exameLaboratorial.formulaExame')
    },
    data: () => ({
        fields: [
            {
                name: 'nome',
                key: 'nome',
                label: 'Nome',
                searchable: true,
                sortable: true
            },
            {
                name: 'fatores',
                key: 'fatores',
                label: 'Fatores',
                searchable: true,
                sortable: true
            },
            {
                name: 'actions',
                key: 'actions',
                label: 'Ações',
                class: 'col-min'
            },
        ],
        repositories: {
            formulaExame: null,
        },
    }),
    methods: {
        handleDestroy({ id }) {

            const destroy = () => this.repositories.formulaExame.destroy(id)
                .then(() => this.$refs.DataTable.refresh())

            this.showDeleteConfirmation('Deseja realmente excluir a fórmula?', destroy, this.handleError)
        },
    },
    mixins: [ repository, error ],
}
</script>